export const navList: VoiceNav[] = [
  {
    value: "all",
    name: "all",
  },
  {
    value: "insight",
    name: "insight",
  },
  {
    value: "spotlight",
    name: "spotlight",
  },
  {
    value: "event",
    name: "event",
  },
  {
    value: "other",
    name: "other",
  },
];

export const newList: NewList[] = [
  {
    id: 18,
    type: "event",
    title:
      "GDPS Exhibition Insights: 3 Days, 100+ AI Entrepreneurs, 4 Confirmed Trends",
    desc: `GDPS 2026 just wrapped up. Over three days, we walked the floor as observers — and what we saw offered one of the most grounded, unfiltered looks at where AI deployment actually stands today. AI has moved from "can it be done?" to "how do we turn it into a business?" We observed four key signals: accelerating AI application maturity, the rise of super entrepreneurs and one-person companies, the rapidly forming Agent ecosystem, and AI's shift from productivity tools to human-centric scenarios.`,
    date: "March 29, 2026",
    img: "",
  },
  {
    id: 19,
    type: "insight",
    title:
      "When AI Is No Longer Just a Partner — FutureX's 30-Day OpenClaw Organizational Upgrade",
    desc: `In 30 days, FutureX Capital went from installing its first ClawBot to becoming an AI-native organization. This is the real record of that transformation — from watching AI agents autonomously evolve in our research group chat, to deploying the FutureX AI Research Lab, to navigating the intersection of the AI Agent wave and geopolitical storm. A story about organizational evolution, boundary exploration, and what it means when AI stops being just a tool.`,
    date: "March 3, 2026",
    img: "",
  },
  {
    id: 20,
    type: "event",
    title:
      "From Experimentation to Daily Use: Consumer AI Hardware Explosion at CES 2026 | FutureX Insight",
    desc: `Entering 2026, consumer AI hardware has built on the maturation trajectory of 2025 — a year defined by major acquisitions from Meta, OpenAI, and others. The market has decisively moved away from speculative "smartphone killers" toward pragmatic, vertically integrated devices. From Meta's dominant Ray-Ban smart glasses to the thriving companion robot market, we examine the categories that won, those that failed, and what proactive intelligence and ambient AI mean for 2026.`,
    date: "January 7, 2026",
    img: "",
  },
  {
    id: 1,
    type: "event",
    title: "FutureX's Silicon Valley AI Tour: A Recap",
    desc: `FutureX Capital recently wrapped up a successful AI-focused trip to Silicon Valley. Themed ‘AI Applications,’ the event delved into integrating AI with fields like AI agents, content commerce, hardware, and social media. Our mission is to discover and foster continuous innovation and breakthroughs in these areas.

This was FutureX’s third event in Silicon Valley, the epicenter of innovation. Over the week, we visited tech giants, dynamic startups, renowned incubators, and our portfolio companies. We had productive meetings with over 40 entrepreneurs, founders, and executives, deepening our insights and expanding our network.

`,
    date: "June 6th, 2024",
    img: "/storage/app/media/Picture11.png",
  },
  {
    id: 2,
    type: "insight",
    title:
      "How AI + Emotional Companionship Is Shaping a Billion-Dollar Future | FutureX Seminar",
    desc: `As technology continues to evolve, a new frontier is emerging at the intersection of LLM and emotional companionship. During a recent seminar hosted by FutureX, industry experts delved into how large language models (LLMs) are not just enhancing technological capabilities but are also poised to unlock vast investment opportunities in a sector that could soon be worth billions. This seminar, driven by a year of comprehensive research, showcased the transformative potential of AI in meeting deep human emotional needs, predicting significant social and business impacts. Below are the key insights from this illuminating session."`,
    date: "May 13, 2024",
    img: "/storage/app/media/WechatIMG3800.jpg",
  },
  {
    id: 3,
    type: "insight",
    title: "FutureX Perspective: Insights from NVIDIA GTC 2024",
    desc: `Last month, the NVIDIA 2024 Global Technology Conference (GTC) captivated the global AI community, filling every seat. The FutureX team had the privilege of joining tech leaders from around the world at this pivotal event, which highlighted NVIDIA's technological milestones and the future trajectory of AI.`,
    date: "April 15, 2024",
    img: "/storage/app/media/uploaded-files/Picture5.jpg",
  },
  {
    id: 4,
    type: "insight",
    title:
      "A Deep Dive into 2024's AI Investment Trends: Insights from Silicon Valley",
    desc: `Recently, FutureX hosted a seminar focused on exploring the investment trends and future directions of the AI industry. This event attracted a broad spectrum of attendees within the FutureX ecosystem. Distinguished guests, including the chairman of Open Source China and the well-known Twitter AI blogger @FinanceYF5, Will, alongside other industry experts, shared their insights on AI development trends and investment opportunities. Below is a summary of the key highlights:`,
    date: "March 29, 2024",
    img: "",
  },
  {
    id: 5,
    type: "spotlight",
    title:
      "FutureX Capital Celebrates Lotus Technology's Historic NASDAQ Debut",
    desc: `FutureX Capital is proud to announce that its portfolio company, Lotus Technology, has made history with its recent merger with SPAC company L Catterton Asia Acquisition Corp (LCAA). As of February 23rd, 2024, Lotus Technology has officially gone public on NASDAQ under the ticker symbol "LOT". This significant milestone represents the fastest Initial Public Offering (IPO) in the history of the electric vehicle sector, and the largest IPO from Chinese companies in the last two years. FutureX Capital, which participated in the Pre-A round financing at the inception of Lotus Technology in 2021, lauds this achievement as a testament to the company's exceptional growth and the rapidly expanding global electric vehicle market.
The global investors warmly welcomed Lotus Technology's debut on the NASDAQ market, with an opening market capitalization exceeding $10 billion. This strong reception underscores the significant market opportunity that FutureX Capital identified when deciding to invest in Lotus Technology.`,
    date: "March 29, 2024",
    img: "/storage/app/media/Picture1.jpg",
  },
  {
    id: 6,
    type: "spotlight",
    title:
      "The Evolution and Constants of FutureX: Persisting in the Hard but Right Choices",
    desc: `In the venture capital and business circles this year, there’s a widespread sense of resignation and anxiety. However, looking back at past challenges such as 9/11, the 2008 economic crisis, and the SARS epidemic, it's evident that as long as we continue to grow, we can overcome any difficulty. Despite a current domestic atmosphere tinged with pessimism, FutureX has achieved rapid development over the past six years, maintaining a positive attitude, struggling alongside the entire FutureX ecosystem, and exploring the boundless possibilities of future technology.`,
    date: "January 26, 2024",
    img: "/storage/app/media/ZEKE9371-opq614246046.jpg",
  },
  {
    id: 7,
    type: "insight",
    title: "AI Investment Guide: Unearthing Trillion-Dollar Market Potential",
    desc: `According to a McKinsey report, the new generation of artificial intelligence technology is expected to create a massive market opportunity worth $2.6 to $4.4 trillion across various industries. While the specific figures are not the central focus, the scale they represent is significant. The widespread application of AI heralds the emergence of a new round of industry giants. Based on this, we have conducted an in-depth analysis of the AI application market and discussed the investment opportunities we have observed.`,
    date: "January 8, 2024",
    img: "",
  },
  {
    id: 8,
    type: "event",
    title:
      "Connecting the Intelligence, Explore the Infinite Possibilities of AI",
    desc: `Recently, FutureX Capital convened the 2023 Investors Summit in Zhuhai. The annual meeting, under the theme FutureX Intelligence Connection, Exploring the Infinite Possibilities of AI,' invited more than 50 distinguished figures from the industry. This included frontline technology entrepreneurs and top experts in areas such as semiconductors, cloud computing, and artificial intelligence. They joined investors in discussing the trends in technological development and future investment opportunities. `,
    date: "November 30, 2023",
    img: "/storage/app/media/Picture12.jpg",
  },
  {
    id: 9,
    type: "other",
    title:
      "FutureX Fund Management (Hong Kong) Limited - Climate-Related Risks Disclosure 2023",
    desc: `FutureX Fund Management (Hong Kong) Limited acknowledges that climate change is emerging as a major driving factor affecting long term resilience in the industry and the global economy. Thereby, this creates an urgent need to accelerate the transition towards a net-zero economy. While climate change poses a systemic and unprecedented risk to the global economy, the impacts on specific markets, regions, communities, and investments are complex, dynamic, and uncertain.`,
    date: "November 20th, 2023",
    img: "/storage/app/media/Screenshot25202023-11-242520at252011.46.292520AM.png",
  },
  {
    id: 10,
    type: "spotlight",
    title: "Congratulations to Cryofocus Medtech for its successful IPO!",
    desc: `On December 30, 2022, FutureX Capital’s portfolio company Cryofocus Medtech (Shanghai) Co., Ltd. (“Cryofocus”) was listed on the Main Board of The Stock Exchange of Hong Kong Limited (HKSE: 6922). As Cryofocus Medtech’s Series B investor, we are optimistic about the leadership position of the company in the cryoablation industry and mass adoption of its technology in the future.`,
    date: "December 30, 2022",
    img: "/storage/app/media/1.png",
  },
  {
    id: 11,
    type: "spotlight",
    title:
      "World-changing Disruptive Innovation Company: Navigating the Opportunites and Challenges featuring ICLeague Foudner Dr Simon Yang",
    desc: `At FutureX Capital, we invest in next-generation leaders who are building the future through technology innovation. As always, we are commited to bringing our tech founders and experts together and having a conversation with our community. On 26th November, 2022, we organized the “World-changing Disruptive Innovation Company: Navigating the Opportunites and Challenges” in-person seminar (with livestreaming session) in Singapore - where we were honored to have Dr. Shining (Simon) Yang , the founder of ICLeague, with us and to share his insights on disruptive innovation in semiconductor industry. Below are the key takeaways from Dr. Yang’s sharing.`,
    date: "December 9th, 2022",
    img: "/storage/app/media/Simon.png",
  },
  {
    id: 12,
    type: "other",
    title:
      "FutureX Fund Management (Hong Kong) Limited - Climate-Related Risks Disclosure",
    desc: `FutureX Fund Management (Hong Kong) Limited acknowledges that climate change is emerging as a major driving factor affecting long term resilience in the industry and the global economy. Thereby, this creates an urgent need to accelerate the transition towards a net-zero economy. While climate change poses a systemic and unprecedented risk to the global economy, the impacts on specific markets, regions, communities, and investments are complex, dynamic, and uncertain.
`,
    date: "November 20th, 2022",
    img: "/storage/app/media/img01.png",
  },
  {
    id: 13,
    type: "event",
    title: `FutureX Capital participated in the "Share and Love" charity event by Shagnhai ADream Foundation`,
    desc: `FutureX Fund Management (Hong Kong) Limited acknowledges that climate change is emerging as a major driving factor affecting long term resilience in the industry and the global economy. Thereby, this creates an urgent need to accelerate the transition towards a net-zero economy. While climate change poses a systemic and unprecedented risk to the global economy, the impacts on specific markets, regions, communities, and investments are complex, dynamic, and uncertain.
`,
    date: "November 18, 2022",
    img: "/storage/app/media/11.png",
  },

  {
    id: 15,
    type: "event",
    title: `Cynthia Zhang, Founding Partner of FutureX Capital, Invited to 2022 Hong Kong Fintech Week to Talk about Financing the Companies of Future
`,
    desc: `On 31 October 2022, FutureX Capital’s Founding Partner, Ms Cynthia Zhang, was invited as guest speaker of the 2022 Hong Kong Fintech Week's Financing the Companies of Tomorrow Panel.
`,
    date: "November 4th, 2022",
    img: "/storage/app/media/aaa.jpg",
  },
  {
    id: 16,
    type: "insight",
    title: `New Energy Sector Changes and Investment Opportunities in the Context of Carbon Neutrality – Part I｜FutureX Webinar`,
    desc: `On July 12, 2022, FutureX held an online seminar on the topic of " Changes and Opportunities in the New Energy Sector in the Era of Carbon Neutrality", and invited world-class experts to share and discuss the topic.
`,
    date: "October 24, 2022",
    img: "/storage/app/media/webimg01.jpeg",
  },
  {
    id: 17,
    type: "spotlight",
    title: `FutureX-backed Jenscare Scientific Lists on the Hong Kong Stock Exchange`,
    desc: `  On October 10, 2022, FutureX Capital’s portfolio company Ningbo Jenscare Scientific Co. Ltd. (stock code: 9877.HK), a medical device company focusing on developing innovative products for the treatment of structural heart disease, was successfully listed on the Main Board of Hong Kong Exchanges and Clearing (HKEX).
`,
    date: "October 10th, 2022",
    img: "/storage/app/media/Image_20221011192755.jpg",
  },
];
